import type { scaleBand, StringLike } from "@visx/scale";


type ScaleBand<T extends StringLike = StringLike> = ReturnType<
    typeof scaleBand<T>
>;


export function invertScaleBand<T extends StringLike = StringLike>(
    scale: ScaleBand<T>,
): (value: number) => T {

    const domain = scale.domain();
    const paddingOuter = scale(domain[0]) ?? 0;
    const eachBand = scale.step();
    return function (value: number) {
        const index = Math.floor(((value - paddingOuter) / eachBand));
        return domain[Math.max(0, Math.min(index, domain.length - 1))];
    };
}
